// extracted by mini-css-extract-plugin
export default {"newsletter":"page1_newsletter__b105k","mobileAndText":"page1_mobileAndText__RQ-bP"};